// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".reading .menu{align-items:center;background-color:#fff;border-bottom:1px solid #343a40;border-left:1px solid #343a40;display:flex;flex:0 0 50px;padding-left:15px;padding-right:15px}.reading .menu .btn{margin-right:15px;width:80px}", ""]);
// Exports
module.exports = exports;
